import { NgbDateStruct, NgbTimeStruct } from "@ng-bootstrap/ng-bootstrap";

export function parseDate(dateString: string) {
    var date = new Date(dateString + (hasTimeZone(dateString) ? '' : '+00:00'));
    return {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear(),
    } as NgbDateStruct;
}

export function parseTime(dateString?: string) {
    if (!dateString) {
        return undefined;
    }

    var date = new Date(dateString + '+00:00');
    return {
        hour: date.getHours(),
        minute: date.getMinutes(),
        second: 0,
    } as NgbTimeStruct;
}

export function dateToString(date: NgbDateStruct) {
    return `${date.year}-${numDate(date.month)}-${numDate(date.day)}T00:00:00.0`;
}

export function prepareDateToUtc(date: NgbDateStruct, time: NgbTimeStruct) {
    const dateTime = new Date(date.year, date.month - 1, date.day, time.hour, time.minute);
    return dateTime.getUTCFullYear() + '-' + numDate(dateTime.getUTCMonth() + 1) + '-' + numDate(dateTime.getUTCDate()) + 'T' + numDate(dateTime.getUTCHours()) + ':' + numDate(dateTime.getUTCMinutes()) + ':00.000+00:00';
}

function numDate(num: number) {
    return num < 10 ? '0' + num : num.toString();
}

function hasTimeZone(str: string) {
    return str.includes('+') || str.includes('Z') || str.includes('z');
}